import { Clock, PanelRight, Plus } from 'lucide-react';

import { Button } from '@/shared/components/shadcn/button';
import { TooltipFlat } from '@/shared/components/shadcn/tooltip/tooltip-flat';
import { cn } from '@/shared/utils/cn';

interface ChatHeaderProps {
  className?: string;
  onNewSession: () => void;
  onToggle?: () => void;
  onExpand?: () => void;
}

export function ChatHeader({ className, onNewSession, onToggle }: ChatHeaderProps) {
  return (
    <div className={cn('bg-secondary relative', className)}>
      <div className="pointer-events-none absolute inset-x-0 bottom-0 border-b border-zinc-200" />
      <div className="flex items-center px-6 py-3">
        <div className="flex flex-1 items-center gap-1">
          {onToggle && (
            <Button
              className="p-1.5 hover:bg-zinc-200"
              variant="ghost"
              size="icon"
              onClick={onToggle}
            >
              <PanelRight className="size-4" />
            </Button>
          )}
          <h2 className="text-base-foreground text-lg font-semibold">Ask Syncly</h2>
          {/* {onExpand && (
            <Button
              className="p-1.5 hover:bg-zinc-200"
              variant="ghost"
              size="icon"
              onClick={onExpand}
            >
              <Maximize2 className="size-4" />
            </Button>
          )} */}
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="icon" className="size-10 bg-white" onClick={onNewSession}>
            <Plus className="size-4" />
          </Button>
          <TooltipFlat asChild triggerClassName="inline-block" content="Show history: coming soon">
            <Button variant="outline" size="icon" className="size-10 bg-white opacity-50" disabled>
              <Clock className="size-4" />
            </Button>
          </TooltipFlat>
        </div>
      </div>
    </div>
  );
}
